/**
 * sticky
 *
 * performs the sticky script whenever the related elements are updated
 */

(function() {
	Vue.directive('sticky', {
		update: function(el, binding, vnode) {
			/* Wait for the DOM to load  https://012.vuejs.org/guide/best-practices.html#Understanding_Async_Updates */
			Vue.nextTick(() => {
				window.initSticky();
			});
		}
	});
})();
